module.exports = __webpack_public_path__ + "e5d3cd379730512156f33f2b9ca87e79.svg";